module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-b5a8f31608691b18f8bd50b8fcbd8f8a.png";